import { CSSTransition } from 'react-transition-group';
import { useGetParams } from './hooks/useGetParams';

import { useVote } from './hooks/useVote';
import VoteFullSize from './components/VoteFullSize/VoteFullSize';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';

function App() {
  const { currentState, isVisible, voteState } = useVote();

  const {
    bgVideo,
    bgPoster,
    questionFontSize,
    answerFontSize,
    varNumFontSize,
  } = useGetParams();

  return (
    <div className="app-wrapper">
      <CSSTransition
        in={isVisible && (currentState === 'S1' || currentState === 'S2')}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <AdvtFullSize />
      </CSSTransition>
      <CSSTransition
        in={
          isVisible &&
          (currentState === 'S1' || currentState === 'S2') &&
          !voteState?.variants
        }
        timeout={500}
        classNames="fade-scale"
        unmountOnExit={false}
      >
        <div className="titre-wrapper">
          {!voteState?.variants &&
            (currentState === 'S1' || currentState === 'S2') && (
              <VoteFullSize
                variants={voteState?.vars}
                title={voteState?.title}
                withResults={true}
                currentState={currentState}
                questionFontSize={questionFontSize}
                answerFontSize={answerFontSize}
                varNumFontSize={varNumFontSize}
              />
            )}
        </div>
      </CSSTransition>

      {bgVideo && (
        <video
          autoPlay="autoplay"
          muted="muted"
          loop
          id="bgVideo"
          poster={bgVideo === '1' ? posterDefault : bgPoster}
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}
      <div id="img-loader"></div>
    </div>
  );
}

export default App;
